import "./btn_learn_more.css";

const LearnMoreBtn = ({link}) => {
   return (
       <div className="learn-more">
           <a href={link}>
               <span> Learn more</span>
               <img
                   src="https://img.icons8.com/ios-filled/ffffff/100/circled-up-right-2.png"
                   alt="circled-up-right-2"
               />
           </a>
       </div>
   )
}

export default LearnMoreBtn;